import styled from "@emotion/styled";

const Tufts = styled.div`
  position: absolute;
  top: 120px;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  flex-wrap: wrap;
  overflow: hidden;
`;

const TuftRow = styled.div<{ hideBelowDesktop?: boolean }>`
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  width: 100vw;
  display: none;

  @media ${(props) => props.theme.bp.mobileUp} {
    display: flex;
  }

  @media ${(props) => props.theme.bp.desktopDown} {
    display: ${({ hideBelowDesktop }) => (hideBelowDesktop ? "none" : "flex")};
  }

  &:first-of-type {
    padding: 0 150px;

    @media ${(props) => props.theme.bp.desktopUp} {
      padding: 0 287px;
    }
  }

  &:nth-of-type(2) {
    padding: 0px 0px 0px 55px;

    @media ${(props) => props.theme.bp.desktopUp} {
      padding: 0px 175px 0px 175px;
    }
  }

  &:last-child {
    padding: 0px 150px;

    @media ${(props) => props.theme.bp.desktopUp} {
      padding: 0 240px;
    }
  }
`;

const Tuft = styled.div`
  background-image: url(/images/app/grass_tuft.png);
  background-repeat: no-repeat;
  padding: 30px;
`;

export const GrassTuftsBackground = () => (
  <Tufts>
    <TuftRow>
      {Array(2)
        .fill(1)
        .map((_, key) => (
          <Tuft key={`row-1-${key}`} />
        ))}
    </TuftRow>
    <TuftRow>
      {Array(2)
        .fill(1, 0, 3)
        .map((isTuft, key) => (isTuft ? <Tuft key={`row-2-${key}`} /> : null))}
    </TuftRow>
    <TuftRow hideBelowDesktop>
      {Array(4)
        .fill(1)
        .map((_, key) => (
          <Tuft key={`row-3-${key}`} />
        ))}
    </TuftRow>
    <TuftRow>
      {Array(2)
        .fill(1)
        .map((_, key) => (
          <Tuft key={`row-4-${key}`} />
        ))}
    </TuftRow>
  </Tufts>
);
